import "./MinistereEmploiLogo.scss";

export default {
  root: "im-ministere-emploi-logo",
  text: "im-ministere-emploi-logo__text",
};
